import type { Size } from "./abstractions.ts";

export const pal: Size = [768, 576];
